module.exports = __webpack_public_path__ + "assets/img/kristopher_blasiak_photo.5386c365.svg";